import React from 'react';
import { useSelector } from 'react-redux';
import Overlay from '../ui/loader/Overlay';
import Spinner from '../ui/loader/Spinner';
import { getLoading } from '../../store/selectors/loading';

const Loader = () => {

    const loading = useSelector(getLoading);

    if(loading) {
        return(
            <Overlay>
                <Spinner animation="border" />
            </Overlay>
        );
    }

    return null;

};

export default Loader;
